export const messages = {
  en: {
    accountBondObjManage: {
      title: 'Bond Object',
      bobjId: 'Bond ID',
      objName: 'Bond Object',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      startTime: 'Start Time',
      endTime: 'End Time'
    }
  },
  zh: {
    accountBondObjManage: {
      title: '保证金对象',
      bobjId: '保证金ID',
      objName: '保证金对象',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      startTime: '开始时间',
      endTime: '结束时间'
    }
  }
}